import { cloneObject, isObject } from "./object-helpers.js";
/**
 * Checks whether the specified variable is a number.
 *
 * @param variable
 * @returns {boolean}
 */
export const isNumber = (variable) => {
    return !isNaN(parseFloat(variable)) && !isNaN(variable - 0);
};
export function deepEqual(a, b) {
    if (a === b)
        return true;
    if (a instanceof Date && b instanceof Date) {
        // If the values are Date, they were convert to timestamp with getTime and compare it
        if (a.getTime() !== b.getTime())
            return false;
    }
    if (a !== Object(a) || b !== Object(b)) {
        // If the values aren't objects, they were already checked for equality
        return false;
    }
    const props = Object.keys(a);
    if (props.length !== Object.keys(b).length) {
        // Different number of props, don't bother to check
        return false;
    }
    return props.every(p => deepEqual(a[p], b[p]));
}
export function isEqualModel(a, b) {
    if (!a || !b) {
        return false;
    }
    return a.model_name === b.model_name && a.id === b.id;
}
export function padNumber(num, length = 2, padEnd = false) {
    let s = num + "";
    while (s.length < length) {
        if (padEnd) {
            s = s + "0";
        }
        else {
            s = "0" + s;
        }
    }
    return s;
}
/**
 * Ensures that all the mandatory data is set on the specified data.
 *
 * @param data
 * @param mandatoryData
 * @returns {*}
 */
export function setMandatoryData(data, mandatoryData) {
    if (!mandatoryData || !Object.keys(mandatoryData).length) {
        return data;
    }
    Object.keys(mandatoryData).forEach(key => {
        const value = mandatoryData[key];
        if (isObject(value)) {
            if (isObject(data[key]) && Object.keys(data[key]).length && Object.keys(value).length) {
                setMandatoryData(data[key], value);
            }
            else {
                data[key] = (isObject(data[key]) && Object.keys(data[key]).length) ? data[key] : cloneObject(value);
            }
        }
        else if (value && (data[key] === null || data[key] === undefined)) {
            data[key] = value;
        }
    });
    return data;
}
/**
 * Iterates over the source data properties and sets the values on the corresponding properties of the target data.
 *
 * @param targetData
 * @param sourceData
 * @returns {*}
 */
export function replaceData(targetData, sourceData) {
    Object.keys(sourceData).forEach(key => {
        const value = sourceData[key];
        if (isObject(targetData[key]) && isObject(value) && Object.keys(value).length) {
            targetData[key] = replaceData(targetData[key], value);
        }
        else {
            targetData[key] = value;
        }
    });
    return targetData;
}
/**
 * Builds the plural version of the specified string.
 *
 * @param {string} string
 * @returns {string}
 */
export function buildPlural(string) {
    if (string && string.endsWith('ss')) {
        return string + 'es';
    }
    if (string && string.endsWith('y')) {
        return string.substr(0, string.length - 1) + 'ies';
    }
    return string && !string.endsWith('s') ? string + 's' : string;
}
//# sourceMappingURL=var-helpers.js.map